import { render, staticRenderFns } from "./EdiPopup.vue?vue&type=template&id=8986561a&scoped=true&"
import script from "./EdiPopup.vue?vue&type=script&lang=js&"
export * from "./EdiPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8986561a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8986561a')) {
      api.createRecord('8986561a', component.options)
    } else {
      api.reload('8986561a', component.options)
    }
    module.hot.accept("./EdiPopup.vue?vue&type=template&id=8986561a&scoped=true&", function () {
      api.rerender('8986561a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Common/EdiPopup.vue"
export default component.exports